import { useEffect, useState } from 'react';
import { Offcanvas } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAxios } from '../../utils/hook/useAxios';
import Nav from '../Nav';
import Navlist from '../Navlist';

function VehicleLayout({ vehicleId, pageTitle, children }) {
  const axios = useAxios();
  const navigate = useNavigate();

  const [menuOpen, setMenuOpen] = useState(false);
  const [vehicle, setVehicle] = useState(null);
  const [annonces, setAnnonces] = useState(null);

  useEffect(() => {
    if (!vehicleId) return;
    axios
      .get('/vehicles/searchbyid/' + vehicleId)
      .then(({ data }) => {
        setVehicle(data);
        window.localStorage.setItem('VehicleStorage', JSON.stringify(data));
      })
      .catch(() => {});

    axios
      .get('/vehicleAnnonces/getbyvehiculeid/' + vehicleId)
      .then(({ data }) => setAnnonces(data || []))
      .catch(() => setAnnonces([]));
  }, [vehicleId]);

  const vehicleLabel = vehicle
    ? `${vehicle.VehicleModel?.marque ?? ''} ${vehicle.VehicleModel?.modele ?? ''}`.trim()
    : '…';

  return (
    <div className="mc-home mc-vehicle-layout">
      {/* ── Offcanvas navigation mobile (react-bootstrap) ── */}
      <Offcanvas
        show={menuOpen}
        onHide={() => setMenuOpen(false)}
        placement="start"
        className="mc-offcanvas"
        style={{ maxWidth: 300 }}
      >
        <Offcanvas.Header closeButton>
          <div className="mc-offcanvas-head">
            <Offcanvas.Title className="mc-offcanvas-title">
              <i className="bi bi-car-front"></i>
              {vehicleLabel}
            </Offcanvas.Title>
            {pageTitle && <p>{pageTitle}</p>}
          </div>
        </Offcanvas.Header>
        <Offcanvas.Body>
          <Navlist vehiculeId={vehicleId} annonces={annonces} />
        </Offcanvas.Body>
      </Offcanvas>

      {/* ── Barre sticky mobile ── */}
      <div className="mc-vehicle-bar">
        <button
          type="button"
          className="mc-btn mc-btn--secondary mc-btn--sm"
          onClick={() => setMenuOpen(true)}
        >
          <i className="bi bi-list"></i>
          Menu
        </button>

        {vehicle?.principalPhotos && (
          <img
            className="mc-vehicle-thumb mc-vehicle-thumb--sm"
            src={vehicle.principalPhotos}
            alt=""
          />
        )}

        <span className="mc-vehicle-bar-name">{vehicleLabel}</span>

        {pageTitle && <span className="mc-page-badge">{pageTitle}</span>}
      </div>

      {/* ── Layout principal ── */}
      <div className="container mc-container">
        <div className="mc-vehicle-nav">
          <Nav />
        </div>

        <div className="mc-vehicle-grid">
          {/* Sidebar desktop — unique instance de Navlist */}
          <aside className="mc-vehicle-sidebar" aria-label="Menu du véhicule">
            <div className="mc-vehicle-sidebar-head">
              {vehicle?.principalPhotos && (
                <img className="mc-vehicle-thumb" src={vehicle.principalPhotos} alt="" />
              )}
              <div>
                <strong>{vehicleLabel}</strong>
                {pageTitle && <small>{pageTitle}</small>}
              </div>
            </div>
            <Navlist vehiculeId={vehicleId} annonces={annonces} />
          </aside>

          <div className="mc-vehicle-content">{children}</div>
        </div>
      </div>
    </div>
  );
}

export default VehicleLayout;
